import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/pagination.vue";
import detailsTable from "./Plugin/detailsTable.vue"
import partsRow from "./Plugin/partsRowTable.vue";
import { domainName, processApi } from "../../../../utility/index";
import axios from 'axios'

export default {
    components: { iTable, IPagination, detailsTable, partsRow },
    data() {
        return {
            formInline: {
                selectCarType: '',
                selectCarValue: '',
                MaintainTime: [],
                materialName: '',
                projectId: [],
            },
            optionsInput: [{
                value: '0',
                label: this.$t('common.all')
            }, {
                value: '1',
                label: this.$t('common.carId')
            }, {
                value: '2',
                label: this.$t('common.plateNum')
            }, {
                value: '3',
                label: this.$t('common.customNum')
            },
            {
                value: '4',
                label: this.$t('common.manufactureNum')
            }],
            height: '500',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [
                {
                    prop: "serialNumber",
                    label: this.$t('VehicleManagement.serialNumber'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "carId",
                    label: this.$t('common.carId'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "manufactureNum",
                    label: this.$t('common.manufactureNum'),
                    align: "center",
                    width: "150px"
                },
                {
                    prop: "customNum",
                    label: this.$t('common.customNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "plateNum",
                    label: this.$t('common.plateNum'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "carWorkTime",
                    label: this.$t('VehicleManagement.carWorkTime'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "operateUser",
                    label: this.$t('VehicleManagement.serialPerson'),
                    align: "center",
                    width: "120px"
                },

                {
                    prop: "operateTime",
                    label: this.$t('VehicleManagement.serialTime'),
                    align: "center",
                    width: "160px"
                },
                {
                    prop: "remarks",
                    label: this.$t('common.remark'),
                    align: "center",

                },
                {
                    prop: "peopleCost",
                    label: this.$t('VehicleManagement.peopleCost'),
                    align: "center",
                    width: "120px"
                },
                {
                    prop: "materialCost",
                    label: this.$t('VehicleManagement.materialCost'),
                    align: "center",
                    width: "120px"
                }
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    {
                        id: '1',
                        show: true,
                        icon: 'iconfont iconicon-chakanxq',
                        plain: true,
                        disabled: false,
                        isBtn: "MAINTENANCEORDER_DETAIL",
                        method: (index, row) => {
                            console.log(index.row)
                            this.dialogOperateVisible = true
                            this.queryDetails()
                            // this.id = row.id
                            this.operateList = row
                        }
                    },
                    {
                        id: '2',
                        show: true,
                        icon: 'iconfont iconxiazai1',
                        plain: true,
                        disabled: false,
                        isBtn: "MAINTENANCEORDER_DETAIL",
                        method: (index, row) => {
                            if (domainName) {
                                if (domainName.split(':')[0] !== 'localhost') {
                                    let url = `https://${domainName}/v1/getExportExcel/exportMaterialData?serialNumber=${row.serialNumber}`
                                    location.href = url
                                } else {
                                    let host = 'localhost:8080'
                                    let url = `https://${host}/v1/getExportExcel/exportMaterialData?serialNumber=${row.serialNumber}`
                                    location.href = url
                                }
                            }

                        }
                    }
                ],
            },
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            btnType: '',
            rules: {
                carId: [
                    { required: true, message: this.$t('VehicleManagement.form.imputCarid'), trigger: 'blur' },
                ],
                operateUser: [
                    { required: true, message: this.$t('VehicleManagement.form.imputMaintainPerson'), trigger: 'blur' }
                ],
                operateTime: [
                    { required: true, message: this.$t('VehicleManagement.form.chooseMaintainTime'), trigger: 'change' }
                ],
            },
            form: {
                serialNumber: '',
                carId: '',
                operateUser: '',
                operateTime: '',
                remarks: '',
                peopleCost: '',
                materialCost: '',
                Cost: '',
                filePath: '',
                maintainProject: '',
                maintainPropose: ''
            },
            imageUrl: '',
            dialogVisible: false,
            // processImg: processApi,
            FileList: [],
            filePath: '',
            dialogProjectFormVisible: false,
            tableDataList: [],
            projectOption: '',
            btnName: "",
            maintainProject: '',
            // id: '',
            operateList: '',
            dialogOperateVisible: false,
            currentPage: 1,
            pageSize: 10,
            total: 1,
            selected: [],
            orgId: '',
            OperateForm: {
                requestSerialNumber: '',
                carId: '',
                carWorkTime: '',
                operateUser: '',
                operateTime: '',
                remarks: '',
                peopleCost: '',
                materialCost: '',
                filePath: '',
                maintainPropose: ''
            },
            OperateLabelWidth: '126px',
            FileOperateList: [],
            processImg: processApi,
            dialogFileOperateVisible: false,
            imageOperateUrl: '',
            activeOperateName: 'first',

            options: [],
            tableData: [],
        }
    },
    created() {
        this.getTreeChange()
    },
    methods: {
        computedPrice(num) {
            console.log(num)
            this.form.materialCost = num
        },
        handleChange(value) {
            console.log(value);
        },
        getTreeChange() {
            this.$store.dispatch('MaintenanceProgram/GET_SELECTTREEFORMPROJECT', {}).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.options = res.data.data
                    }
                }
            }).catch(err => { })
        },
        getOrderList() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.MaintainTime) {
                if (this.formInline.MaintainTime.length > 0) {
                    startTime = this.formInline.MaintainTime[0]
                    endTime = this.formInline.MaintainTime[1]
                }
            }
            let param = {
                orgId: this.orgId,
                selectCarType: this.formInline.selectCarType,
                selectCarValue: this.formInline.selectCarValue,
                materialName: this.formInline.materialName,
                projectId: this.formInline.projectId[1],
                startTime: startTime,
                endTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('MaintenanceManagement/GET_QUERYORDERLIST', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.currentPage = 1
            this.getOrderList()
        },
        onClear() {
            this.formInline = {
                selectCarType: '',
                selectCarValue: '',
                MaintainTime: [],
                materialName: '',
                projectId: [],
            }
            this.getOrderList()
        },

        closeDia() {
            this.form = {
                serialNumber: '',
                carId: '',
                operateUser: '',
                operateTime: '',
                remarks: '',
                peopleCost: '',
                materialCost: '',
                filePath: ''
            }
            this.dialogFormVisible = false;
        },

        editReminder() {
            this.dialogFormVisible = true
            this.diaTitle = this.$t('common.btn.edit')
            this.btnType = 'edit'
            this.form.serialNumber = this.selected[0].serialNumber
            this.form.carId = this.selected[0].carId
            this.form.operateUser = this.selected[0].operateUser
            this.form.operateTime = this.selected[0].operateTime
            this.form.remarks = this.selected[0].remarks
            this.form.peopleCost = this.selected[0].peopleCost
            this.form.materialCost = this.selected[0].materialCost
            // this.form.Cost = this.selected[0].materialCost
            this.form.filePath = this.selected[0].filePath
            this.btnName = this.selected[0].projectCount + "个项目"
            let filteredArr = this.selected[0].maintainProject && this.selected[0].maintainProject?.filter(obj => {
                return obj.projectOption !== null && obj.projectOption !== "null" && obj.projectOption !== ""
            });
            this.form.maintainProject = filteredArr
            this.form.maintainPropose = this.selected[0].maintainPropose


            // this.FileList = []
            this.$nextTick(() => {
                this.$refs.diaTable.tableData = this.selected[0].maintainMaterialPoList
                // this.$refs.form.clearValidate()
            })
            // this.FileOperateList = [];
            // const arr = this.operateList.filePath.split(',')
            // arr.forEach(filePath => {
            //     this.FileOperateList.push({
            //         url: filePath,
            //     });
            // });

        },

        handlePictureCardPreview(file) {
            this.imageUrl = file.url;
            this.dialogVisible = true;
        },
        handleRemove(file, fileList) {
            this.FileList = []
            const arr = []
            fileList.map((item) => {
                this.FileList.push({
                    name: item.name,
                    url: item.url,
                    uid: item.uid
                })
                arr.push(item.url)
            })
            this.form.filePath = arr.join(',')
        },

        handleAvatarSuccess(res, file) {
            const arr = []
            this.FileList.push({
                url: res[0],
            })
            this.FileList.map(item => {
                arr.push(item.url)
            })
            this.form.filePath = arr.join(',')
        },
        beforeUpload(file) {
            console.log(file)
            let acceptList = ["jpg", "png", "pdf"]
            let fileType = file.name.split('.').pop().toLowerCase()
            if (acceptList.indexOf(fileType) === -1) {
                this.$message.error('只能上传 pdf/jpg/png 格式的文件 !');
                return false
            }

            // if (file.size / 1024 / 1024 > 1) {
            //     this.$message.error('上传文件大小不能超过 1M !');
            //     return false
            // }
        },
        changeProject() {
            this.dialogProjectFormVisible = true
            this.tableDataList = this.selected[0].maintainProject
            this.tableDataList.map(item => {
                item.projectOption = String(item.projectOption)
            })
        },
        objectSpanMethodEdit({ row, column, rowIndex, columnIndex }) {
            let columnArr = [0]
            let projectbArr = [];
            for (let k in this.tableDataList) {
                projectbArr.push(this.tableDataList[k].project)
            }
            let obj = {}
            for (let i = 0; i < projectbArr.length; i++) {
                if (obj[projectbArr[i]] == undefined) {
                    obj[projectbArr[i]] = 1
                } else {
                    obj[projectbArr[i]]++
                }
            }
            let spanArr = [];
            let doneArr = []
            for (let i = 0; i < projectbArr.length; i++) {
                if (doneArr.includes(projectbArr[i])) {
                    spanArr.push(0)
                } else {
                    spanArr.push(obj[projectbArr[i]])
                    doneArr.push(projectbArr[i])
                }
            }
            if (columnArr.includes(columnIndex)) {
                for (let i = 0; i < spanArr.length; i++) {
                    if (rowIndex == i) {
                        return {
                            rowspan: spanArr[i],
                            colspan: 1
                        }
                    }
                }
            }
        },
        changeRadio(index, row) {
            this.tableDataList.map(item => {
                if (item.projectName == row.projectName) {
                    row.projectOption = index
                }
            })
            let arr = []
            arr.push({
                projectId: row.id,
                projectOption: row.projectOption
            })
            this.maintainProject = arr.concat(this.maintainProject)
        },
        submitProject() {
            let filteredArr = this.tableDataList && this.tableDataList.filter(function (obj) {
                return obj.projectOption != null && obj.projectOption != "" && obj.projectOption != "null"
            });
            console.log(filteredArr)
            if (filteredArr.length > 0) {
                this.btnName = filteredArr.length + "个项目"
            }
            // else {
            //     this.btnName = "选择项目"
            // }
            // console.log(this.tableDataList)
            this.form.maintainProject = filteredArr
            this.dialogProjectFormVisible = false
            this.maintainProject = []
        },
        cancleProject() {
            this.dialogProjectFormVisible = false
        },
        closeProjectDia() {
            this.dialogProjectFormVisible = false
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    console.log(this.btnName)
                    if (this.btnName === '选择项目') {
                        this.$message.error('请选择保养项目');
                        // alert('请选择保养项目')
                    } else {
                        let param = {
                            serialNumber: this.form.serialNumber,
                            carId: this.form.carId,
                            operateUser: this.form.operateUser,
                            operateTime: this.form.operateTime,
                            remarks: this.form.remarks,
                            peopleCost: this.form.peopleCost,
                            filePath: this.form.filePath,
                            maintainMaterialList: JSON.stringify(this.$refs.diaTable.tableData),
                            maintainProject: JSON.stringify(this.form.maintainProject),
                            maintainPropose: this.form.maintainPropose,
                            materialCost: this.form.materialCost
                        }
                        this.$store.dispatch('MaintenanceManagement/GET_UPDATEMATERIAL', param).then(res => {
                            if (res.data.code == 200) {
                                this.$message.success(this.$t('common.btn.editSuccess'))
                                this.dialogFormVisible = false;
                                this.getOrderList();
                                this.closeDia();
                            } else {
                                this.$message.error(res.data.msg)
                            }

                        }).catch(err => { })
                    }

                }
            });
        },
        cancle(formName) {
            this.dialogFormVisible = false;
            this.form = {
                carId: '',
                operateUser: '',
                operateTime: '',
                remarks: '',
                peopleCost: '',
                materialCost: '',
                filePath: ''
            }
        },


        closeOperateDia() {
            this.dialogOperateVisible = false
        },
        handleOperateClick(event) {
            this.activeOperateName = event.name
            if (this.activeOperateName == 'first') {
                this.queryDetails()
            } else if (this.activeOperateName == 'second') {
                this.queryDetails()
            } else {
                this.$refs.detailTable.id = this.operateList.id
                this.$refs.detailTable.getDetailList()
            }

        },
        queryDetails() {
            this.$nextTick(() => {
                this.OperateForm = {
                    // type: this.operateList.type,
                    requestSerialNumber: this.operateList.serialNumber,
                    carId: this.operateList.carId,
                    carWorkTime: this.operateList.carWorkTime,
                    operateUser: this.operateList.operateUser,
                    operateTime: this.operateList.operateTime,
                    remarks: this.operateList.remarks,
                    peopleCost: this.operateList.peopleCost,
                    materialCost: this.operateList.materialCost,
                    filePath: this.operateList.filePath,
                    maintainPropose: this.operateList.maintainPropose
                }
                // this.FileOperateList = [];
                // const arr = this.operateList.filePath.split(',')
                // arr.forEach(filePath => {
                //     this.FileOperateList.push({
                //         url: filePath,
                //     });
                // });
                this.tableData = this.operateList.maintainProject
                this.tableData.map(item => {
                    item.projectOption = String(item.projectOption)
                })
            })
        },
        previewPdf() {
            window.open(this.operateList.filePath, '_blank');
        },
        indexMethod(index) {
            return index + 1;
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            let columnArr = [0]
            let projectbArr = [];
            for (let k in this.tableData) {
                projectbArr.push(this.tableData[k].project)
            }
            let obj = {}
            for (let i = 0; i < projectbArr.length; i++) {
                if (obj[projectbArr[i]] == undefined) {
                    obj[projectbArr[i]] = 1
                } else {
                    obj[projectbArr[i]]++
                }
            }
            let spanArr = [];
            let doneArr = []
            for (let i = 0; i < projectbArr.length; i++) {
                if (doneArr.includes(projectbArr[i])) {
                    spanArr.push(0)
                } else {
                    spanArr.push(obj[projectbArr[i]])
                    doneArr.push(projectbArr[i])
                }
            }
            if (columnArr.includes(columnIndex)) {
                for (let i = 0; i < spanArr.length; i++) {
                    if (rowIndex == i) {
                        return {
                            rowspan: spanArr[i],
                            colspan: 1
                        }
                    }
                }
            }
        },

        deleteCar() {
            this.$confirm(`${this.$t('common.btn.confirmDelete')}`, `${this.$t('common.btn.delete')}`, {
                cancelButtonText: `${this.$t('common.btn.cancel')}`,
                confirmButtonText: `${this.$t('common.btn.confirm')}`,
                type: 'warning'
            }).then(res => {
                let param = {
                    serialNumber: this.selected[0].serialNumber
                }
                this.$store.dispatch('MaintenanceManagement/GET_DELETEMATERIAL', param).then(response => {
                    if (response.data.code == 200) {
                        this.getOrderList()
                        this.$message.success(this.$t('common.btn.deleteSuccess'))
                    } else {
                        this.$message.error(response.data.msg)
                    }
                }).catch(error => { })
            }).catch(err => {

            })
        },

        handleOperatePictureCardPreview(file) {
            this.imageOperateUrl = file.url;
            this.dialogFileOperateVisible = true;
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getOrderList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}